import axios from 'axios'
import router from '../router'; 
import { Message } from 'element-ui'

const http = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 1000 * 600,
	withCredentials: true
})

// 重试配置
const retryConfig = {
	maxRetries: 3,
	retryDelay: 1000,
	retryableStatusCodes: [0, 502, 503, 504] // 0 表示网络错误
}

// 请求计数器，用于生成唯一的请求ID
let requestId = 0

/**
 * 生成请求ID
 */
function generateRequestId() {
	return ++requestId
}

/**
 * 延迟函数
 */
function delay(ms) {
	return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * 发送请求（带重试机制）
 */
async function requestWithRetry(config, retryCount = 0) {
	const requestId = generateRequestId()
	const configWithId = { ...config, requestId }

	try {
		return await http(configWithId)
	} catch (error) {
		// 判断是否应该重试
		const shouldRetry =
			retryCount < retryConfig.maxRetries &&
			(error.code === 'ECONNABORTED' || // 超时
			!error.response || // 网络错误
			retryConfig.retryableStatusCodes.includes(error.response?.status) ||
			error.message?.includes('Network Error'))

		if (shouldRetry) {
			console.log(`请求 ${requestId} 失败，${retryCount + 1}/${retryConfig.maxRetries} 次重试...`)
			await delay(retryConfig.retryDelay * (retryCount + 1)) // 递增延迟
			return requestWithRetry(config, retryCount + 1)
		}

		throw error
	}
}

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
	let accessToken = sessionStorage.getItem("accessToken");
	if (accessToken) {
		config.headers.accessToken = encodeURIComponent(accessToken);
	}
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	if (response.data.code == 200) {
		return response.data.data;
	} else if (response.data.code == 400) {
		return exit();
	} else if (response.data.code == 401) {
		console.log("token失效，尝试重新获取")
		let refreshToken = sessionStorage.getItem("refreshToken");
		if (!refreshToken) {
			return exit()
		}
		// 发送请求, 进行刷新token操作, 获取新的token
		const data = await http({
			method: 'put',
			url: '/refreshToken',
			headers: {
				refreshToken: refreshToken
			}
		}).catch(() => {
			exit();
		})
		// 保存token
		sessionStorage.setItem("accessToken", data.accessToken);
		sessionStorage.setItem("refreshToken", data.refreshToken);
		// 重新发送刚才的请求
		return http(response.config)
	} else {
		Message({
			message: response.data.message,
			type: 'error',
			duration: 2000,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(response.data)
	}
}, error => {
	// 网络错误或超时
	if (!error.response) {
		Message({
			message: '网络不稳定，请检查网络后重试',
			type: 'error',
			duration: 3000,
			customClass: 'element-error-message-zindex'
		})
	} else {
		switch (error.response.status) {
			case 400:
				Message({
					message: error.response.data || '请求参数错误',
					type: 'error',
					duration: 2000,
					customClass: 'element-error-message-zindex'
				})
				break
			case 401:
				exit();
				break
			case 405:
				Message({
					message: 'http请求方式有误',
					type: 'error',
					duration: 2000,
					customClass: 'element-error-message-zindex'
				})
				break
			case 413:
				Message({
					message: '文件太大，服务器无法接收',
					type: 'error',
					duration: 3000,
					customClass: 'element-error-message-zindex'
				})
				break
			case 404:
			case 500:
				Message({
					message: '服务器出了点小差，请稍后再试',
					type: 'error',
					duration: 2000,
					customClass: 'element-error-message-zindex'
				})
				break
			case 501:
				Message({
					message: '服务器不支持当前请求所需要的某个功能',
					type: 'error',
					duration: 2000,
					customClass: 'element-error-message-zindex'
				})
				break
			default:
				Message({
					message: '上传失败，请重试',
					type: 'error',
					duration: 2000,
					customClass: 'element-error-message-zindex'
				})
		}
	}

	return Promise.reject(error)
})

const exit = () => {
	router.app.$eventBus.$emit("exit")
}


export default http
